export default __webpack_public_path__ + "static/media/video_icon.28efe348.svg";